/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import Tippy from '@tippyjs/react';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { userSelectStyles } from './user';

const values = [...Array(12).keys()].map((i) => i + 1);

export const RepeatIntervalLabels = (day: string) => {
  return <Tippy content={day[0].toUpperCase() + day.substring(1)} />;
};

export const renderRepeatInterval = (day: string) => {
  return RepeatIntervalLabels(day[0].toUpperCase() + day.substring(1));
};

export const repeatIntervalOptions = () => {
  const repeatIntervalList: { label: string; value: string }[] = [];
  values.forEach((value) => {
    repeatIntervalList.push({
      label: value < 10 ? `0${value.toString(10)}`.toString() : value.toString(10),
      value: value.toString(),
    });
  });
  return repeatIntervalList;
};

export const getRepeatIntervalLabel = (value: number) => {
  return repeatIntervalOptions()[value - 1].label;
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const repeatIntervalSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),
    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const RepeatIntervalSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const RepeatIntervalSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
